import type { Legal, NavLinkColumn } from './types'

export const legal_au: Legal[] = [
  {
    key: 'privacy_notice',
    name: 'Privacy Notice',
    href: '/privacy/australia',
  },
  {
    key: 'status',
    name: 'Status',
    href: 'https://status.crypto.com',
  },
]

export const desktop_au: NavLinkColumn[] = [
  [
    {
      tTitle: 'products.app',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.buyAndSell',
          href: '/au/app',
        },
        {
          tTitle: 'products.earn',
          href: '/au/earn',
        },
        {
          tTitle: 'products.credit',
          href: '/au/credit',
        },
        {
          tTitle: 'products.pay',
          href: '/au/pay',
        },
      ],
    },
    {
      tTitle: 'products.cards',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.metalCards',
          href: '/au/cards',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.exchange',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.exchangeIndex',
          href: 'https://crypto.com/exchange',
        },
        {
          tTitle: 'products.syndicate',
          href: 'https://crypto.com/exchange/syndicate',
        },
        {
          tTitle: 'products.supercharger',
          href: 'https://crypto.com/exchange/supercharger',
        },
        {
          tTitle: 'products.tradingArena',
          href: 'https://crypto.com/exchange/trading-arena',
        },
      ],
    },
    {
      tTitle: 'products.commerce',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.payMerchant',
          href: '/au/pay-merchant',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.defi',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.wallet',
          href: '/au/defi-wallet',
        },
        {
          tTitle: 'products.swap',
          href: 'https://crypto.com/defi/swap',
        },
        {
          tTitle: 'products.defiEarn',
          href: '/au/defi-wallet#earn',
        },
        {
          tTitle: 'products.dashboard',
          href: 'https://crypto.com/defi/dashboard/gas-fees',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'products.resources',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'products.prices',
          href: 'https://crypto.com/price',
        },
        {
          tTitle: 'products.siteWidgets',
          href: 'https://crypto.com/price/widget',
        },
        {
          tTitle: 'products.tax',
          href: 'https://tax.crypto.com',
        },
        {
          tTitle: 'company.support',
          href: 'https://help.crypto.com/en',
        },
        {
          tTitle: 'products.por',
          href: '/au/proof-of-reserves',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.learn',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'learn.trending',
          href: '/trending',
        },
        {
          tTitle: 'learn.productNews',
          href: '/product-news',
        },
        {
          tTitle: 'learn.events',
          href: '/events',
        },
        {
          tTitle: 'learn.university',
          href: '/university',
        },
        {
          tTitle: 'learn.research',
          href: '/research',
        },
        {
          tTitle: 'learn.marketUpdates',
          href: '/market-updates',
        },
        {
          tTitle: 'learn.nftStories',
          href: '/nft-stories',
        },
      ],
    },
  ],
  [
    {
      tTitle: 'navbar.company',
      tBadgeTitle: null,
      href: null,
      items: [
        {
          tTitle: 'company.about',
          href: '/au/about',
        },
        {
          tTitle: 'company.careers',
          href: '/au/careers',
        },
        {
          tTitle: 'company.news',
          href: 'https://crypto.com/company-news',
        },
        {
          tTitle: 'company.security',
          href: '/au/security',
        },
        {
          tTitle: 'company.contact',
          href: '/au/about#page-contact',
        },
        {
          tTitle: 'company.capital',
          href: '/au/capital',
        },
        {
          tTitle: 'company.climate',
          href: 'https://crypto.com/company-news/crypto-coms-climate-commitment-2',
        },
        {
          tTitle: 'company.affiliate',
          href: '/au/affiliate',
        },
        {
          tTitle: 'company.partners',
          href: '/au/partners',
        },
        {
          tTitle: 'navbar.nft',
          href: 'https://crypto.com/nft',
          tBadgeTitle: 'navbar.new',
        },
      ],
    },
  ],
]

export const mobile_au = desktop_au
  .flatMap((menu) => menu)
  .map(({ items, ...rest }) => ({
    items: items.filter(({ tTitle }) => tTitle !== 'navbar.nft'),
    ...rest,
  }))
  .concat([
    {
      tTitle: 'navbar.nft',
      tBadgeTitle: 'navbar.new',
      href: 'https://crypto.com/nft',
      items: [],
    },
  ])
